module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--help"
  }, [_c('div', {
    staticClass: "help"
  }, [_c('div', {
    staticClass: "help__content"
  }, [_c('h1', {
    staticClass: "h1 mb2 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p ",
    domProps: {
      "innerHTML": _vm._s(_vm.content.bodyCopy)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.share)
    }
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "secondary",
      "link": "support",
      "label": "Go back"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.illustration,
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e142ba2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/help/OthersHelp.vue
// module id = 555
// module chunks = 0